import ProjectHeroBrainFlix from "../../../components/ProjectHero/BrainFlix/ProjectHeroBrainFlix";
import ProjectDetailsBrainFlix from "../../../components/ProjectDetails/BrainFlix/ProjectDetailsBrainFlix";


function ProjectPageBrainFlix() {
    return (
        <>
            <ProjectHeroBrainFlix />
            <ProjectDetailsBrainFlix />
        </>
    )
}

export default ProjectPageBrainFlix;